import { createClient } from '@supabase/supabase-js';

// Replace these with your actual Supabase project URL and anon key
// You can find these in your Supabase project settings -> API
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'YOUR_SUPABASE_URL';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'YOUR_SUPABASE_ANON_KEY';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

/*
===========================================
SUPABASE SETUP GUIDE
===========================================

1. Buat akun di https://supabase.com (gratis)

2. Buat project baru:
   - Klik "New Project"
   - Isi nama project, password database, dan pilih region

3. Setelah project dibuat, buat table "models" dengan struktur:
   - Buka SQL Editor di Supabase dashboard
   - Jalankan query berikut:

CREATE TABLE models (
  id UUID DEFAULT gen_random_uuid() PRIMARY KEY,
  name VARCHAR(255) NOT NULL,
  gender VARCHAR(50) NOT NULL,
  type VARCHAR(50) NOT NULL CHECK (type IN ('kids', 'adult')),
  height INTEGER,
  weight INTEGER,
  top_size VARCHAR(50),
  pants_size VARCHAR(50),
  shoes_size VARCHAR(50),
  image_1 TEXT,
  image_2 TEXT,
  image_3 TEXT,
  image_4 TEXT,
  created_at TIMESTAMP WITH TIME ZONE DEFAULT NOW(),
  updated_at TIMESTAMP WITH TIME ZONE DEFAULT NOW()
);

-- Enable Row Level Security (RLS)
ALTER TABLE models ENABLE ROW LEVEL SECURITY;

-- Create policy untuk read access (public)
CREATE POLICY "Allow public read access" ON models
  FOR SELECT USING (true);

-- Create policy untuk insert/update/delete (authenticated users)
CREATE POLICY "Allow authenticated insert" ON models
  FOR INSERT WITH CHECK (auth.role() = 'authenticated');

CREATE POLICY "Allow authenticated update" ON models
  FOR UPDATE USING (auth.role() = 'authenticated');

CREATE POLICY "Allow authenticated delete" ON models
  FOR DELETE USING (auth.role() = 'authenticated');

-- Insert sample data
INSERT INTO models (name, gender, type, height, weight, top_size, pants_size, shoes_size, image_1, image_2, image_3, image_4) VALUES
('Aisyah Putri', 'Female', 'kids', 120, 25, 'S', '24', '30', '/assets/models/kids1-1.jpg', '/assets/models/kids1-2.jpg', '/assets/models/kids1-3.jpg', '/assets/models/kids1-4.jpg'),
('Budi Santoso', 'Male', 'kids', 115, 22, 'S', '22', '28', '/assets/models/kids2-1.jpg', '/assets/models/kids2-2.jpg', '/assets/models/kids2-3.jpg', '/assets/models/kids2-4.jpg'),
('Citra Dewi', 'Female', 'adult', 165, 52, 'M', '28', '38', '/assets/models/adult1-1.jpg', '/assets/models/adult1-2.jpg', '/assets/models/adult1-3.jpg', '/assets/models/adult1-4.jpg'),
('Dimas Pratama', 'Male', 'adult', 175, 70, 'L', '32', '42', '/assets/models/adult2-1.jpg', '/assets/models/adult2-2.jpg', '/assets/models/adult2-3.jpg', '/assets/models/adult2-4.jpg');

4. Dapatkan API credentials:
   - Buka Settings -> API di Supabase dashboard
   - Copy "Project URL" dan "anon public" key

5. Buat file .env di root project:

REACT_APP_SUPABASE_URL=your_supabase_url
REACT_APP_SUPABASE_ANON_KEY=your_supabase_anon_key

6. Restart development server setelah menambah .env

===========================================
*/


